import React from "react";
import {
  convertThenFormat,
  formatDateTime,
} from "../../../common-data/Converts";

const LeadOverview = ({ rowData }) => {
  return (
    <div className="lead-journey-overview-root">
      <div className="lead-journey-overview-top">
        <div className="lead-journey-card lead-journey-contact-card">
          <div className="lead-journey-card-title">
            <span className="lead-journey-card-title-icon">📞</span>
            Contact Information
          </div>

          <div className="lead-journey-card-row">
            <span className="lead-journey-card-label">Phone:</span>
            <span className="lead-journey-card-value">
              {rowData.mobile || "-"}
            </span>
          </div>

          <div className="lead-journey-card-row">
            <span className="lead-journey-card-label">Email:</span>
            <span className="lead-journey-card-value lowercase">
              {rowData.email || "-"}
            </span>
          </div>

          <div className="lead-journey-card-row">
            <span className="lead-journey-card-label">Gym:</span>
            <span className="lead-journey-card-value">
              {rowData.gym_name || "-"}
            </span>
          </div>

          <div className="lead-journey-card-row">
            <span className="lead-journey-card-label">Assigned Agent:</span>
            <span className="lead-journey-card-value">
              {rowData.assigned_to_name || "-"}
            </span>
          </div>
        </div>

        <div className="lead-journey-card lead-journey-metrics-card">
          <div className="lead-journey-card-title">
            <span className="lead-journey-card-title-icon">📈</span>
            Lead Metrics
          </div>

          <div className="lead-journey-card-row">
            <span className="lead-journey-card-label">Lead Value:</span>
            <span className="lead-journey-card-value">
              ₹{convertThenFormat(rowData.lead_value || 0)}
            </span>
          </div>

          <div className="lead-journey-card-row">
            <span className="lead-journey-card-label">Converted Value:</span>
            <span className="lead-journey-card-value lead-journey-green">
              ₹{convertThenFormat(rowData.converted_value || 0)}
            </span>
          </div>

          <div className="lead-journey-card-row">
            <span className="lead-journey-card-label">Source:</span>
            <span className="lead-journey-card-value">
              {rowData.source_name?.replace(/_/g, " ") || "-"}
            </span>
          </div>

          <div className="lead-journey-card-row">
            <span className="lead-journey-card-label">Calls Made:</span>
            <span className="lead-journey-card-value">
              {rowData.total_outgoing_call || "0"} total,{" "}
              {rowData.total_outgoing_connected_call || "0"} connected
            </span>
          </div>

          <div className="lead-journey-card-row">
            <span className="lead-journey-card-label">Date Added:</span>
            <span className="lead-journey-card-value">
              {rowData.date_added ? formatDateTime(rowData.date_added.split(" ")[0]) : "N/A"}
            </span>
          </div>
        </div>
      </div>

      <div className="lead-journey-status-card">
        <div className="lead-journey-status-title">Current Status</div>
        <div className="lead-journey-status-box">
          <div className="lead-journey-status-main">
            {rowData.current_followup_status?.replace(/_/g, " ") || "-"}
          </div>
          <div className="lead-journey-status-next">
            Next Follow-up: {formatDateTime(rowData?.next_followup_date)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadOverview;
